<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/parent' }">
        <app-i18n code="entities.parent.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.parent.view.title"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.parent.view.title"></app-i18n>
      </h1>

      <div class="app-page-spinner" v-if="loading" v-loading="loading"></div>

      <app-parent-view-toolbar v-if="record"></app-parent-view-toolbar>

      <el-form
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        @submit.prevent.native
        class="form"
        v-if="record"
      >
        <app-view-item-text :label="fields.id.label" :value="presenter(record, 'id')"></app-view-item-text>

        <app-view-item-text :label="fields.firstName.label" :value="presenter(record, 'firstName')"></app-view-item-text>
        
        <app-view-item-text :label="fields.lastName.label" :value="presenter(record, 'lastName')"></app-view-item-text>
        
        <app-view-item-text :label="fields.gender.label" :value="presenter(record, 'gender')"></app-view-item-text>

        <app-view-item-text :label="fields.phoneNumber.label" :value="presenter(record, 'phoneNumber')"></app-view-item-text>
        
        <app-view-item-text :label="fields.email.label" :value="presenter(record, 'email')"></app-view-item-text>

        <app-view-item-text :label="fields.createdAt.label" :value="presenter(record, 'createdAt')"></app-view-item-text>

        <app-view-item-text :label="fields.updatedAt.label" :value="presenter(record, 'updatedAt')"></app-view-item-text>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ParentViewToolbar from '@modules/parent/components/parent-view-toolbar.vue';
import { ParentModel } from '@modules/parent/parent-model';

export default {
  name: 'app-parent-view-page',

  props: {
    id: {
      type: String,
      required: true
    },
    
    subpropertyId: {
      type: String,
      required: true
    }
  },

  components: {
    [ParentViewToolbar.name]: ParentViewToolbar,
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'parent/view/record',
      loading: 'parent/view/loading',
      dateFormat: 'auth/manage/dateFormat',
      timeFormat: 'auth/manage/timeFormat',
    }),

    fields() {
      const { dateFormat, timeFormat} = this;
      return new ParentModel({ dateFormat, timeFormat }).fields();
    },
  },

  async created() {
    await this.doFind({ id: this.id, subpropertyId: this.subpropertyId});
  },

  methods: {
    ...mapActions({
      doFind: 'parent/view/doFind',
    }),

    presenter(record, fieldName) {
      const { dateFormat, timeFormat} = this;
      return new ParentModel({ dateFormat, timeFormat }).presenter(record, fieldName);
    },
  },
};
</script>
